export enum DashboardReportType {
	DEFAULT = 'DEFAULT',
	FRONTLINE = 'FRONTLINE',
}
